import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 50px 0;
  width: 50%;

  @media (max-width: 728px) {
    width: 100%;
  }
`;

export const BoxNumbers = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: end;
  gap: 5px;
`;

export const ItemAround = styled.div`
  border: 1px solid gray;
  padding: 5px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  cursor: pointer;
`;

export const ItemFocus = styled.div`
  border: 1px solid gray;
  padding: 5px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  cursor: pointer;

  background-color: #448d5f;
  color: white;
`;
